export default {"src":"/_next/static/media/roeien.3854d72a.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};